import { apiRequest } from "../util/apiUtils";
import { registerSaveKind, trackSave } from "../util/saveTracker";

/**
 * Background saves that report on the "Saved" pill, retry when they fail and
 * survive a closed tab (util/saveTracker.js).
 *
 * apiRequest never throws: a lost request resolves to undefined and an HTTP
 * error to the error response. These turn both into failures the tracker can
 * see. A 4xx other than a timeout or rate limit is permanent (retrying a
 * request the server rejected would only loop), so it is dropped.
 */
function okOrThrow(res) {
  if (res && res.status < 400) return res;
  const error = new Error(res ? `HTTP ${res.status}` : "No response");
  if (res && res.status < 500 && res.status !== 408 && res.status !== 429) error.permanent = true;
  throw error;
}

const putBookEdit = (payload) => apiRequest("put", "book/edit", { body: payload }).then(okOrThrow);
const patchPageOrder = (payload) => apiRequest("patch", "media/ordering", { body: payload }).then(okOrThrow);

registerSaveKind("bookEdit", putBookEdit);
registerSaveKind("pageOrder", patchPageOrder);

/** Save some of a book's fields ({ id, title } or { id, introKeyword, description } ...). */
export function saveBookFields(payload) {
  const fields = Object.keys(payload).filter((k) => k !== "id").sort().join(",");
  return trackSave(() => putBookEdit(payload), { key: `book:${payload.id}:${fields}`, kind: "bookEdit", payload });
}

/** Save the interior page order ({ ordering_data } as built by buildInteriorOrderingPayload). */
export function savePageOrder(payload) {
  return trackSave(() => patchPageOrder(payload), { key: "pageOrder", kind: "pageOrder", payload });
}
